module.exports = __webpack_public_path__ + "img/2019_b_s_s_m.f9a7a947.jpg";